import arrayMutators from 'final-form-arrays';

const commonMutators = {
  ...arrayMutators,
};

export default commonMutators;
